import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { summarizeCareScenario } from '@shared/consumerPlan';
import { useClientData } from '@/hooks/useClientData';
import { type AppState, selectClient } from '@/model';

/** The signed-in consumer's client record with its care plan summarised for the flow. */
export function useConsumerClient(clientId: string) {
  const { client: maybeClient, isLoading } = useClientData();
  const isLoaded = maybeClient?.clientId === clientId;
  const client = useSelector((state: AppState) => (isLoaded ? selectClient(state) : null));
  const scenario = useMemo(() => (client ? summarizeCareScenario(client) : null), [client]);

  return { client, scenario, isLoading: isLoading || !isLoaded };
}
